import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
let dayjs = require('dayjs');
console.log(dayjs());
import Swiper from 'swiper';
import { BMapLoader } from '@/utils/bdMap.js';
import styleJson1 from '@/view/map/json/custom_map_config.json';
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, setImgsize, getformitemsdata, getImg } from "@/utils/utils";

/**
 * 配置表
 * @param {String} formId 表单接口标识 1078666
 * @param {String} url 表单加密规则 config202402261348
 * @param {String} t 加密串 b2363e4419b835ad7848673afb79732383825a93035ae6268d91df56c28f60d9
 */
/**
 * 打卡
 * @param {String} formId 表单接口标识 1078859
 * @param {String} url 表单加密规则 clockIn202402231705
 * @param {String} t 加密串 5c63ca8bb22b57701b796c069e5618d31838e364615b9ea94f1161c5b1664675
 */
/**
 * 团队申请
 * @param {String} formId 表单接口标识 1059398
 * @param {String} url 表单加密规则 teamapply202402231612
 * @param {String} t 加密串 9a33d3c41cd509eb4794e46c376641d3cb372f5a11d78917d362ce3fb72373ed
 */
/**
 * 团队类型
 * @param {String} formId 表单接口标识 1078747
 * @param {String} url 表单加密规则 teamtype202402281639
 * @param {String} t 加密串 28672dbf4d555d5118b3387e9277124cf9bc01ec887c892376d2f19e46237588
 */

export default {
  name: 'starmap',
  meta: {
    title: '繁星地图'
  },
  components: {},
  data() {
    return {
      BMap: '',
      BDMap: '',
      isMobile: false,
      pointform: {
        deptId: this.$route.query.fid,
        formId: '1078859',
        limit: 100,
        page: 1,
        searchStr: '',
        t: '5c63ca8bb22b57701b796c069e5618d31838e364615b9ea94f1161c5b1664675'
      },
      cycleform: {
        filters: [{
          alias: 'datetime',
          compt: 'numberinput',
          express: '><',
          range: [{
            express: '>=',
            val: ''
          }, {
            express: '<=',
            val: ''
          }]
        }],
        model: 0
      },
      pointList: [],
      logo: {
        type: '',
        // 0文字 1图片
        text: '',
        image: ''
      },
      legend: {
        show: false,
        image: ''
      },
      teamtypeArr: [],
      cycleArr: ['全部', '年', '季度', '月', '周'],
      cycle: 0,
      iconList: [{
        url: require('@/assets/map/star/icon1.png')
      }],
      popDialog: false,
      pdetail: {},
      swiperIndex: 0
    };
  },
  mounted() {
    this.getMapconfig();
    if (document.body.clientWidth < 926) this.isMobile = true;
  },
  watch: {},
  methods: {
    /**
     * 加载百度地图
     * @param {Object} data 配置表数据
     */
    LoadBdmap(data) {
      let that = this;
      this.$nextTick(() => {
        BMapLoader().then(BMap => {
          this.BMap = BMap;
          let zoom = data[13] !== '' ? data[13] : 12;
          this.BDMap = new BMap.Map('bdcontainer', {
            enableMapClick: false,
            maxZoom: 17
          });
          // 显示当前地址
          if (data[12] !== '') {
            let point = data[12].split(',');
            this.centerpoint = new BMap.Point(point[0], point[1]);
            this.BDMap.centerAndZoom(this.centerpoint, zoom);
            // this.BDMap.clearOverlays()
            // let marker = new BMap.Marker(this.centerpoint)
            // this.BDMap.addOverlay(marker)
          }
          this.BDMap.enableScrollWheelZoom(true);
          // 加载个性化主题
          this.BDMap.setMapStyleV2({
            styleJson: styleJson1
          });
          /* 获取团队类型 */
          this.getTeamtype(BMap);
        });
      });
    },
    /**
     * 获取地图配置数据
     * @param {Number} fid 单位FID
     * @param {Number} formUserId 表单行ID
     * @param {String} t 加密串
     */
    getMapconfig() {
      // 繁星配置表
      let configform = {
        fid: this.$route.query.fid,
        formUserId: '',
        t: 'b2363e4419b835ad7848673afb79732383825a93035ae6268d91df56c28f60d9'
      };
      let that = this;
      configform.formUserId = this.$route.query.formUserId;
      this.$api.getFormDetail(configform.fid, configform.formUserId, configform.t).then(res => {
        console.log(res);
        if (res.formUserList.length > 0) {
          let data = {};
          res.formUserList[0].formData.forEach(item => {
            data[transformStr3(item.alias)] = getformitemsdata(item);
          });
          that.voluation(data);
        }
      });
    },
    /**
     * 地图配置数据赋值
     * @param {Object} data 配置表数据
     */
    voluation(data) {
      console.log(data);
      document.title = data[2];
      this.LoadBdmap(data);
      /* 处理logo */
      if (!this.isMobile) {
        if (data[3] === '文字') {
          this.logo.type = 0;
          this.logo.text = data[4];
        } else {
          this.logo.type = 1;
          this.logo.image = getImg(data[5][0]);
        }
      } else {
        if (data[7] === '文字') {
          this.logo.type = 0;
          this.logo.text = data[8];
        } else {
          this.logo.type = 1;
          this.logo.image = getImg(data[9][0]);
        }
      }
      /* 处理图例 */
      if (data[22] === '是') {
        this.legend.show = true;
        this.legend.image = handleHttp(data[23][0].fileUrl);
      } else {
        this.legend.show = false;
        this.legend.image = '';
      }
      /* 处理统计周期 */
      this.cycleArr.forEach((item, index) => {
        if (item === data[11]) this.cycle = index;
      });
      switch (this.cycle) {
        case 1:
          const ystart = dayjs().startOf('year').valueOf();
          const yend = dayjs().endOf('year').valueOf();
          this.cycleform.filters[0].range[0].val = ystart;
          this.cycleform.filters[0].range[1].val = yend;
          this.pointform.searchStr = this.cycleform;
          break;
        case 2:
          const qstart = dayjs().startOf('quarter').valueOf();
          const qend = dayjs().endOf('quarter').valueOf();
          this.cycleform.filters[0].range[0].val = qstart;
          this.cycleform.filters[0].range[1].val = qend;
          this.pointform.searchStr = this.cycleform;
          break;
        case 3:
          const mstart = dayjs().startOf('month').valueOf();
          const mend = dayjs().endOf('month').valueOf();
          this.cycleform.filters[0].range[0].val = mstart;
          this.cycleform.filters[0].range[1].val = mend;
          this.pointform.searchStr = this.cycleform;
          break;
        case 4:
          const wstart = dayjs().startOf('week').add(1, 'day').valueOf();
          const wend = dayjs().endOf('week').add(1, 'day').valueOf();
          this.cycleform.filters[0].range[0].val = wstart;
          this.cycleform.filters[0].range[1].val = wend;
          this.pointform.searchStr = this.cycleform;
          break;
        default:
          this.pointform.searchStr = '';
          break;
      }
      this.pointform.searchStr = encodeURI(JSON.stringify(this.pointform.searchStr));
      console.log(`this.cycle`, this.cycle);
      console.log(`this.pointform.searchStr`, this.pointform.searchStr);
    },
    /**
     * 团队类型表单
     * @param {Object} BMap 百度地图实例
     */
    getTeamtype(BMap) {
      let teamform = {
        deptId: this.$route.query.fid,
        formId: '1078747',
        limit: 100,
        page: 1,
        t: '28672dbf4d555d5118b3387e9277124cf9bc01ec887c892376d2f19e46237588'
      };
      let that = this;
      this.$api.singleadvanceSearchv2(teamform).then(res => {
        that.teamtypeArr = [];
        if (res.dataList.length > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            that.teamtypeArr.push(itemformat);
          });
        }
        that.getPoint(BMap, that.teamtypeArr);
      });
    },
    /**
     * 打卡表数据 添加到地图
     * @param {Object} BMap 百度地图实例
     * @param {Array} teamtypeArr 团队类型数据
     */
    getPoint(BMap, teamtypeArr) {
      let that = this;
      this.$api.singleadvanceSearchv2(this.pointform).then(res => {
        if (res.dataList.length > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            that.createPoint(item, BMap, teamtypeArr);
          });
          that.pointList = that.pointform.page === 1 ? res.pointList : that.pointList.concat(res.dataList);
          if (res.totalPage === 1) return;
          that.pointform.page++;
          if (res.totalPage >= that.pointform.page) that.getPoint();
        }
      });
    },
    /**
     * 创建地图定位点
     * @param {Object} item 定位点信息
     * @param {Object} BMap 百度地图实例
     * @param {Array} teamtypeArr 团队类型数据
     */
    createPoint(item, BMap, teamtypeArr) {
      let that = this;
      let point = item.itemformdata.address[0];
      let cZoom = this.BDMap.getZoom();
      let iwidth = 30;
      let iheight = 30;
      let pointIcon = new BMap.Icon(this.iconList[0].url, new BMap.Size(iwidth, iheight));
      if (teamtypeArr.length > 0) {
        let cteamtype = teamtypeArr.filter(child => {
          return child[1] === item.itemformdata.teamtypeId;
        });
        console.log(cteamtype);
        pointIcon = new BMap.Icon(getImg(cteamtype[0][3][0]), new BMap.Size(iwidth, iheight));
      }
      let marker = new BMap.Marker(new BMap.Point(point.lng, point.lat), {
        icon: pointIcon,
        title: item.itemformdata.name
      });
      this.BDMap.addOverlay(marker);
      marker.addEventListener('click', function (e) {
        that.mapclick(e, item);
      });
    },
    /**
     * 定位点点击事件
     * @param {Object} e 点击对象
     * @param {Object} item 定位点信息
     */
    mapclick(e, item) {
      this.popDialog = true;
      this.pdetail = item.itemformdata;
      this.$nextTick(() => {
        let galleryThumbs = new Swiper('.smallbox .gallery-thumbs', {
          spaceBetween: 20,
          slidesPerView: 6,
          navigation: {
            nextEl: '.smallbox .swiper-button-next',
            prevEl: '.smallbox .swiper-button-prev'
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          observer: true,
          observerParents: true
        });
        let galleryTop = new Swiper('.gallery-top', {
          spaceBetween: 20,
          thumbs: {
            swiper: galleryThumbs
          },
          autoplay: {
            delay: 5000,
            disableOnInteraction: true
          },
          observer: true,
          observerParents: true,
          on: {
            slideChangeTransitionEnd: function () {
              this.swiperIndex = this.activeIndex;
            }
          }
        });
      });
    },
    /**
     * 图片更换域名
     * @param {String} data 图片路径
     */
    getImg(data) {
      return handleHttp(data);
    }
  }
};